define('widgets/olark/viewmodel',[
    'underscore',
    'knockout'
], function (_, ko) {

    var HelpViewModel = function (
        getField,
        app,
        olark,
        formFields,
        olarkTranslationPage,
        olarkLoginModel,
        session,
        olarkSpecificSession
    ) {
        var self = this;

        self.isOpen = ko.observable(false);
        self.isVisible = ko.observable(false);
        self.initialized = ko.observable(false);
        self.hasChatStared = ko.observable(false);

        self.emailField = formFields.emailField(olarkLoginModel.email);
        self.loginIDField  = formFields.textField(olarkLoginModel.name.firstName);

        self.loginIDFieldLabel = getTranslation('NAME_INPUT_TEXT');
        self.emailFieldLabel = getTranslation('EMAIL_INPUT_TEXT');
        self.startChattingText = getTranslation('INTRODUCTION_SUBMIT_BUTTON_TEXT');
        self.introductionMessages = getTranslation('INTRODUCTION_MESSAGES');

        ko.computed(function () {
            self.emailField.value(olark.email());
            self.loginIDField.value(olark.name());
        });

        self.tryOpen = function () {
            !self.isOpen() && self.open(true);
        };
        self.show = function (show) {
            self.isVisible(show);
        };
        self.open = function (show) {
            var userData;

            if (!self.initialized()) {
                self.initialized(true);
                olark.initialize('mobile');
            }
            self.isOpen(show);
            if (session.loggedIn()) {
                userData = olarkSpecificSession();
                self.emailField.value(userData.email);
                self.loginIDField.value(userData.fullName);
            }
        };
        self.allowChildrenControls = function () {
            return true;
        };

        self.text = olark.olarkStatusText;

        self.isHelpEnabled = olark.isEnabled;

        function getTranslation(key) {
            var translations = olarkTranslationPage('translations')();

            return _.filter(translations, function (translation) {
                return translation.key === key;
            })[0].value;
        }

        function getOlarkStatus() {
            return olark.olarkReady.waitForValue(function (v) {
                return v;
            });
        }

        self.startConversation = function () {
            return getOlarkStatus().then(function () {
                olark.startConversation(self.emailField.value(), self.loginIDField.value());
            });
        };

    };

    return HelpViewModel;
});

